
import { Component, OnDestroy } from '@angular/core';
import { RoutesConst } from '@carm/shared/constants/const-routes';
import { GroupTypes, CarmResources } from '@carm/_core';
import { Subject } from 'rxjs';
import { AppInjector } from './app.injector';

@Component({ template: '' })
export abstract class BaseComponent implements OnDestroy {

  public groupTypeEnum = GroupTypes;
  public carmResourcesEnum = CarmResources;
  public routesConstEnum = RoutesConst;

  protected destroy$ = new Subject();

  constructor(
  ) {
    const injector = AppInjector.getInjector();
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }
}
